import Lottie from 'lottie-react'
import { Box, BoxProps } from '~/components/Layout'
import animationData from './loading.json'

export interface LottieLoadingProps {
  width?: string | number
  height?: string | number
  boxProps?: BoxProps
}

const defaultLottieProps: LottieLoadingProps = {
  width: 64,
  height: 64,
  boxProps: {},
}

const LottieLoading: React.FC<LottieLoadingProps> = ({
  width = defaultLottieProps.width,
  height = defaultLottieProps.height,
  boxProps = defaultLottieProps.boxProps,
}) => {
  return (
    <Box {...boxProps}>
      <Lottie
        animationData={animationData}
        loop
        style={{ width, height, margin: '0 auto' }}
      />
    </Box>
  )
}

export default LottieLoading
